"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _IDate = _interopRequireDefault(require("../../../common/iObjects/IDate"));

var _Button = _interopRequireDefault(require("../../Button"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _createStyled = require("../../../utils/createStyled");

function template() {
  var _this = this;

  var styles = this.compileStyled(_index["default"]),
      _this$state = this.state,
      weekDays = _this$state.weekDays,
      firstWeekDay = _this$state.firstWeekDay,
      layoutDate = _this$state.layoutDate,
      _this$props = this.props,
      theme = _this$props.theme,
      yearChange = _this$props.yearChange,
      isPeriod = _this$props.isPeriod,
      monthName = _l10n["default"].translate(layoutDate.getMonthName()),
      month = layoutDate.toString('mm'),
      year = layoutDate.get('year');

  var nextYear = null,
      prevYear = null; // year change buttons

  if (yearChange) {
    prevYear = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.controlLeft,
      "data-qa-node": "prev-year"
    }, _react["default"].createElement(_IconButton["default"], {
      icon: theme.yearDecreaseIcon,
      onClick: function onClick() {
        return _this.shift(-1, 'year');
      }
    }));
    nextYear = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.controlRight,
      "data-qa-node": "next-year"
    }, _react["default"].createElement(_IconButton["default"], {
      icon: theme.yearIncreaseIcon,
      onClick: function onClick() {
        return _this.shift(1, 'year');
      }
    }));
  } // week days list


  var weekDaysHtml = weekDays.map(function (day) {
    return _react["default"].createElement(_createStyled.Styled.Td, {
      styles: styles.weekDay,
      key: day
    }, _l10n["default"].translate(day));
  }); // calendar dates

  var monthStart = true;
  var calendar = [],
      // count of days in month
  daysCount = this.getDaysCount(); // перебираем все числа месяца

  var _loop = function _loop() {
    var row = []; // формирование недели

    weekDays.forEach(function (weekDay, i) {
      var periodOverlay = null,
          dateHtml = null; // если месяц начинается не с понедельника, оставляем пробелы

      if (monthStart && firstWeekDay > i) {
        row.push(_react["default"].createElement("td", {
          key: "day-".concat(i)
        })); // добрались до существующих дней в неделе
      } else {
        monthStart = false;
        var date = daysCount.shift();
        date = String(date).length < 2 ? '0' + date : date;

        if (date) {
          var dateObj = new _IDate["default"](year + '-' + month + '-' + date),
              isStartSelected = _this._isStartOfPeriod(dateObj),
              isEndSelected = _this._isEndOfPeriod(dateObj),
              dayOfMonth = dateObj.get('date'); // маска выбранного периода под числом даты


          if (_this._isDateInPeriod(dateObj)) {
            var periodOverlayStyle = styles.period; // старт периода || первый день недели в месяце || первое число месяца

            if (isStartSelected || dayOfMonth === 1 || i === 0) {
              periodOverlayStyle = styles.periodStart;
            } // конец периода || последний день недели || последний день месяца


            if (isEndSelected || i === 6 || !daysCount.length) {
              periodOverlayStyle = styles.periodEnd;
            }

            if ( // первое число выпадает на последний день недели
            dayOfMonth === 1 && i === 6 || // последнее число выпадает на первый день недели
            !daysCount.length && i === 0) {
              periodOverlayStyle = styles.periodCircle;
            } // исключения для показа маски периода


            if ( // начало периода - последний день недели
            isStartSelected && i === 6 || // конец периода - первый день недели
            isEndSelected && i === 0 || // первое число месяца - конец выбранного периода
            dayOfMonth === 1 && isEndSelected || // начало и конец периода совпадают
            _this._isOneDayPeriod() || // конец периода выпадает на последний день месяца
            isStartSelected && !daysCount.length) {
              periodOverlayStyle = styles.periodNoFill;
            }

            periodOverlay = _react["default"].createElement(_createStyled.Styled.Div, {
              styles: periodOverlayStyle
            });
          }

          var dateStyle = styles.date;

          if (_this._isTodaySelected()) {
            dateStyle = styles.dateToday;
          }

          if (periodOverlay) {
            dateStyle = styles.datePassive;
          }

          if (isStartSelected || isEndSelected) {
            dateStyle = styles.dateSelected;
          }

          if (_this._isForbiddenDate(dateObj)) {
            dateStyle = styles.dateDisabled;
          } // дата календаря


          dateHtml = _react["default"].createElement(_createStyled.Styled.Div, {
            styles: dateStyle,
            onClick: function onClick() {
              return _this.select(dateObj);
            },
            "data-qa-node": "date",
            "data-qa-value": date
          }, date);
        } // календарь


        row.push(_react["default"].createElement(_createStyled.Styled.Td, {
          styles: styles.day,
          key: "day-".concat(i)
        }, periodOverlay, dateHtml));
      }
    });
    calendar.push(_react["default"].createElement("tr", {
      key: "row-".concat(daysCount.length)
    }, row));
  };

  while (daysCount.length) {
    _loop();
  }

  var controls = null;

  if (isPeriod) {
    controls = _react["default"].createElement("tr", null, _react["default"].createElement("td", {
      colSpan: "7"
    }, _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.calendarFooter
    }, _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.calendarBtnCancel
    }, _react["default"].createElement(_Button["default"], {
      flatPrimary: true,
      onClick: this.cancel,
      "data-qa-node": "cancel"
    }, _l10n["default"].translate('DATEPICKER_CANCEL'))), _react["default"].createElement(_createStyled.Styled.Div, null, _react["default"].createElement(_Button["default"], {
      primary: true,
      onClick: this.submit,
      "data-qa-node": "select"
    }, _l10n["default"].translate('DATEPICKER_OK'))))));
  }

  return _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.root,
    className: this.props.className || ''
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.calendar
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.calendarHead
  }, _react["default"].createElement("table", null, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, _react["default"].createElement(_createStyled.Styled.Td, {
    colSpan: "7",
    styles: styles.control
  }, _react["default"].createElement("div", null, prevYear, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.controlLeft,
    "data-qa-node": "prev-month"
  }, _react["default"].createElement(_IconButton["default"], {
    icon: theme.monthDecreaseIcon,
    onClick: function onClick() {
      return _this.shift(-1, 'month');
    }
  }))), _react["default"].createElement(_createStyled.Styled.Span, {
    styles: styles.controlDate,
    "data-qa-node": "month-year"
  }, monthName, "\xA0", year), _react["default"].createElement("div", null, nextYear, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.controlRight,
    "data-qa-node": "next-month"
  }, _react["default"].createElement(_IconButton["default"], {
    icon: theme.monthIncreaseIcon,
    onClick: function onClick() {
      return _this.shift(1, 'month');
    }
  })))))))), _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.calendarBody
  }, _react["default"].createElement("table", null, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, weekDaysHtml), calendar), _react["default"].createElement("tfoot", null, controls)))));
}